import PropTypes from 'prop-types'
import { useTranslation } from 'next-i18next'

// Internal Components
import Button from '../Button/Button'
import OverviewExplainer from '../OverviewExplainer/OverviewExplainer'
import { useContext } from 'react'
import { UserContext } from '../../context/UserContext'

const OverviewHeader = (props) => {
  const { type, data } = props

  const userContext = useContext(UserContext)
  // Translations
  const { t } = useTranslation(
    userContext?.userSession?.sportType?.slug ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_NAMESPACE ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_SPORT
  )

  return (
    <div className="OverviewHeader">
      <div className="OverviewHeader-inner">
        <div className="OverviewHeader-container">
          {data?.explainer && (
            <div className="OverviewHeader-explainer">
              <OverviewExplainer data={data.explainer} />
            </div>
          )}
          {(type === 'exercises' || type === 'trainings' || type === 'programs') && (
            <div className="OverviewHeader-buttonGroup">
              {type === 'exercises' && (
                <Button
                  label={t('OVERVIEWHEADER__BTN_CREATE_EXERCISE')}
                  modal={{ type: 'api', route: 'create/exercise/open', modifier: 'Modal--splitscreen' }}
                  icon={{ id: 'icon-add' }}
                  modifiers={['Button--overviewHeader']}
                />
              )}
              {type === 'trainings' && (
                <Button
                  label={t('OVERVIEWHEADER__BTN_CREATE_TRAINING')}
                  modal={{ type: 'api', route: 'create/training/open' }}
                  icon={{ id: 'icon-add' }}
                  modifiers={['Button--overviewHeader']}
                />
              )}
              {type === 'programs' && (
                <Button
                  label={t('OVERVIEWHEADER__BTN_CREATE_PROGRAM')}
                  modal={{ type: 'api', route: 'create/program/open' }}
                  icon={{ id: 'icon-add' }}
                  modifiers={['Button--overviewHeader']}
                />
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

OverviewHeader.propTypes = {
  type: PropTypes.string,
  data: PropTypes.object
}

export default OverviewHeader
